import { useMediaQuery, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@rentspree/component-2023.components.atoms.typography'
import { forwardRef } from 'react'

import { useSelector } from 'store'
import { selectPublicListingAddressDetails } from 'store/public-listing'

import { ListingDynamicMap } from './listing-dynamic-map'
import { ListingStaticMap } from './listing-static-map'

interface LocationProps {
  isPreview?: boolean
  position?: {
    lat: number
    lng: number
  }
}

const Location = forwardRef<HTMLDivElement, LocationProps>(({ isPreview, position }, ref) => {
  const propertyAddress = useSelector(selectPublicListingAddressDetails)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  if (!position) return null

  return (
    <Box sx={{ paddingBottom: '40px', paddingTop: '32px' }} id="about-the-neighborhood" ref={ref}>
      <Typography variant="h3" fontSize={isMobile ? 24 : 32} sx={{ marginBottom: '24px' }}>
        About the neighborhood
      </Typography>
      {isPreview ? (
        <ListingStaticMap position={position} />
      ) : (
        <ListingDynamicMap position={position} zoom={15} propertyAddress={propertyAddress} />
      )}
    </Box>
  )
})

Location.displayName = 'Location'

export default Location
